import { useState } from "react";
import { useMutation } from "react-query";
import { addToCartUrl, DAYSMART_CHECKOUT_URL, TimeSlot } from "./api";
import { Button, Modal } from "../components";
import { dateToShortTime, loadViaIframe } from "../lib";

const BOOK_INFO_SEEN_KEY = "seenBookInfo";

export function BookButton(props: {
  slot: TimeSlot;
  smaller?: boolean;
  inactive?: boolean;
}) {
  const [showModal, setShowModal] = useState(false);
  const { inactive } = props;

  const mutation = useMutation(async (tab: Window | null) => {
    await loadViaIframe(addToCartUrl(props.slot, "sharks"));
    if (tab) tab.location.href = DAYSMART_CHECKOUT_URL;
  });

  function proceed() {
    const tab = window.open("about:blank", "_blank");
    mutation.mutate(tab);
  }

  function handleClick(e: React.MouseEvent) {
    e.stopPropagation();
    if (inactive) return;
    if (!localStorage.getItem(BOOK_INFO_SEEN_KEY)) {
      setShowModal(true);
    } else {
      proceed();
    }
  }

  return (
    <>
      <Button
        onClick={handleClick}
        smaller={props.smaller}
        textClass="text-2xl"
        inert={inactive}
      >
        {mutation.isLoading ? (
          <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
        ) : (
          dateToShortTime(props.slot.dateTime)
        )}
      </Button>
      {showModal && (
        <Modal>
          <h2 className="text-2xl mb-4">heads up!</h2>
          <p className="text-lg mb-6 text-text-secondary">
            make sure you're already logged in to daysmart. if you're not,
            you'll be taken to their login page — just log in and come back to
            try again.
          </p>
          <Button
            fullWidth
            textClass="text-xl"
            onClick={() => {
              localStorage.setItem(BOOK_INFO_SEEN_KEY, "1");
              setShowModal(false);
              proceed();
            }}
          >
            got it!
          </Button>
        </Modal>
      )}
    </>
  );
}
